<div class="project-component" style="margin-top: 20px;">
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">

  </div>
  <div style="display: flex; flex-direction: row;" [ngStyle]="{ gap: collapsed ? '0': '40px' }">
    <div style="display: flex; flex-direction: column; margin-left: 40px;position:relative; padding-top: 30px;" [ngStyle]="{ flex: collapsed ? '0 0 30px': '0 0 200px' }"
         class="list">
      <div style="position: absolute; top:10px; right: 10px;" (click)="collapsed = !collapsed">
        <i [class]="collapsed ? 'pi pi-angle-double-right' : 'pi pi-angle-double-left'"></i>
      </div>
      <div *ngIf="!collapsed" style="margin-left: 30px">
        <h3>{{pageTitle}}</h3>
        <div *ngFor="let audit of audits" style="white-space: nowrap; display: flex; flex-direction: row; flex:0 1 auto">
          <a style="display: inline-block;text-overflow: ellipsis;width: 100%;overflow:hidden"
             pTooltip="{{audit.name}}" [routerLink]="['/audit', audit.auditId]"
             class="training-link" routerLinkActive="active">{{audit.name || "Default"}}</a>
        </div>
        <div style="margin-left: 10px;">
          <a (click)="createAudit()">
            <div class="fa fa-plus"></div>
          </a>
        </div>
      </div>
    </div>
    <div style="width: calc(100% - 300px);" *ngIf="selectedAudit">
      <mat-form-field style="width: 50%; margin-right: 10px">
        <input matInput [(ngModel)]="selectedAudit.name"/>
      </mat-form-field>
      <button mat-raised-button
              (click)="saveAudit()">
        Save
      </button>
      <span class="icon-delete" (click)="deleteAudit()"></span>
      <mat-tab-group>
        <mat-tab label="Prep Lists" *ngIf="!isAssessor">
          <mat-tab-group>
            <mat-tab [label]="tab.name" *ngFor="let tab of subTabs">
              <p-table
                [value]="groupedAuditItems[tab.tab]"
                scrollable="true"
              >

                <ng-template pTemplate="header">
                  <tr style="white-space: nowrap;font-weight: bold">
                    <th *ngFor="let col of prepCols" [pSortableColumn]="col.field"
                        [ngStyle]="{'width': col.width || 'auto'}">
                      {{col.header}}
                    </th>
                    <th style="width:10em" pFrozenColumn alignFrozen="right"></th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-item>
                  <tr [pSelectableRow]="item">
                                       <td>
                      <ng-container *ngIf="item.editMode">
                        <mat-form-field class="example-full-width" style="width: 100%;">
                          <mat-label>ID</mat-label>
                          <input matInput [(ngModel)]="item.externalId" />
                        </mat-form-field>
                      </ng-container>
                      <ng-container *ngIf="!item.editMode">
                        {{item.externalId}}
                      </ng-container>
                    </td>

                    <td>
                      <ng-container *ngIf="item.editMode">
                        <mat-form-field class="example-full-width" style="width: 100%;">
                          <mat-label>Item</mat-label>
                          <input matInput [(ngModel)]="item.name" />
                        </mat-form-field>
                      </ng-container>
                      <ng-container *ngIf="!item.editMode">
                        {{item.name}}
                      </ng-container>
                    </td>
                    <td *ngIf="isMaster">
                      <ng-container *ngIf="item.editMode">
                         <mat-form-field style="width: 100%">
                           <mat-label>Owner</mat-label>
                          <input matInput [(ngModel)]="item.recommendedOwner" />
                        </mat-form-field>
                      </ng-container>
                      <ng-container *ngIf="!item.editMode">
                        {{item.recommendedOwner}}
                      </ng-container>
                    </td>
                    <td *ngIf="!isMaster">
                      <ng-container *ngIf="item.editMode">
                         <mat-form-field style="width: 100%">
                          <mat-select [(ngModel)]="item.ownerId"
                                      [placeholder]="'Owner' + (item.recommendedOwner ?  '(' + item.recommendedOwner + ')' : '')">
                            <mat-option *ngFor="let user of users"
                                        [value]="user.userId">{{getFullName(user)}}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </ng-container>
                      <ng-container *ngIf="!item.editMode">
                        {{getFullNameById(item.ownerId)}}
                      </ng-container>
                    </td>
                    <td>
                      <ng-container *ngIf="item.editMode">
                         <mat-form-field style="width: 100%">
                           <mat-label>Due Date</mat-label>
                          <input matInput
                                 [matDatepicker]="picker"
                                 name="item.dueDate"

                                 [(ngModel)]="item.dueDate">
                          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                          <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                      </ng-container>
                      <ng-container *ngIf="!item.editMode">
                        {{item.dueDate | date : 'shortDate'}}
                      </ng-container>
                    </td>
                    <td>
                      <button type="button" pButton class="risksponge-button" (click)="item.editMode = true"
                              *ngIf="!item.editMode"
                              icon="pi pi-pencil"></button>
                      <button type="button" pButton class="risksponge-button"
                              (click)="item.editMode = false; saveAuditItem(item)" *ngIf="item.editMode"
                              icon="pi pi-check"></button>
                      <button type="button" pButton class="risksponge-button"
                              (click)="item.editMode = false;" *ngIf="item.editMode"
                              icon="pi pi-times"></button>
                      <button type="button" pButton class="risksponge-button" (click)="removeAuditItem(item)"
                              icon="pi pi-trash"></button>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
              <span class="pi pi-plus"
                    (click)="groupedAuditItems[tab.tab].push({editMode: true, auditId: auditId, tab: tab.tab})"></span>
            </mat-tab>
          </mat-tab-group>
        </mat-tab>

        <mat-tab label="Follow-Up" *ngIf="!isMaster && !isAssessor">
          <p-table
            [value]="groupedAuditItems[4]"
            scrollable="true"
          >

            <ng-template pTemplate="header">
              <tr style="white-space: nowrap;font-weight: bold">
                <th *ngFor="let col of followCols" [pSortableColumn]="col.field"
                    [ngStyle]="{'width': col.width || 'auto'}">
                  {{col.header}}
                </th>
                <th style="width:10em" pFrozenColumn alignFrozen="right"></th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
              <tr [pSelectableRow]="item">
                                   <td>
                      <ng-container *ngIf="item.editMode">
                        <mat-form-field class="example-full-width" style="width: 100%;">
                          <mat-label>ID</mat-label>
                          <input matInput [(ngModel)]="item.externalId" />
                        </mat-form-field>
                      </ng-container>
                      <ng-container *ngIf="!item.editMode">
                        {{item.externalId}}
                      </ng-container>
                    </td>

                <td>
                  <ng-container *ngIf="item.editMode">
                    <mat-form-field
                      floatLabel="always">
                      <mat-label>Category</mat-label>
                      <input matInput
                             [(ngModel)]="item.type"
                      >

                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{item.type}}
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngIf="item.editMode">
                    <mat-form-field class="example-full-width" style="width: 100%;">
                      <mat-label>Description</mat-label>
                      <input matInput [(ngModel)]="item.name" />
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{item.name}}
                  </ng-container>
                </td>
                <td>
                  <div>
                    <ng-container *ngFor="let file of item.attachments">
                      <div>
                        <a
                          href="{{api + '/api/attachments/file?name=' + encodeURIComponent(file.internalName) + '&path=Audit/' + '&token=' + token}}">{{file.name}}</a>
                        <span class="pi pi-trash" (click)="deleteAttachment(file.attachmentId)"></span>
                      </div>
                    </ng-container>
                  </div>

                  <label type="button"
                         [for]="'flieBloba' + rowIndex"
                         class="risksponge-button"
                         pTooltip="Add File. {{this.constants.ATTACHMENT_FILE_DESCRIPTION}}">
                    <span class="pi pi-plus"></span>
                  </label>
                  <input [id]="'flieBloba' + rowIndex"
                         type="file"
                         accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                         (change)="addAttachment($event, item)"
                         [name]="'addAttachedFilea' + rowIndex"
                         style="display: none;"/>
                </td>
                <td>
                  <ng-container *ngIf="item.editMode">
                     <mat-form-field style="width: 100%">
                      <mat-select [(ngModel)]="item.requestorId">
                        <mat-option *ngFor="let user of users"
                                    [value]="user.userId">{{getFullName(user)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{getFullNameById(item.requestorId)}}
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngIf="item.editMode">
                     <mat-form-field style="width: 100%">
                      <mat-select [(ngModel)]="item.ownerId">
                        <mat-option *ngFor="let user of users"
                                    [value]="user.userId">{{getFullName(user)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{getFullNameById(item.ownerId)}}
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngIf="item.editMode">
                     <mat-form-field style="width: 100%">
                       <mat-label>Due Date</mat-label>
                      <input matInput
                             [matDatepicker]="picker"
                             name="item.dueDate"

                             [(ngModel)]="item.dueDate">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{item.dueDate | date : 'shortDate'}}
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngIf="item.editMode">
                     <mat-form-field style="width: 100%">
                      <mat-select [(ngModel)]="item.previousId">
                        <mat-option *ngFor="let previousItem of groupedAuditItems[5]"
                                    [value]="previousItem.auditItemId">
                          <div style="display: flex; flex-direction: row;">
                            <div style="flex:0 0 30px">{{previousItem.auditItemId}}</div>
                            <div style="flex:1 1 auto">{{previousItem.name}}</div>
                          </div>
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{item.previousId}}
                  </ng-container>
                </td>
                <td>{{item.created | date:'shortDate'}}</td>
                <td>
                  <button type="button" pButton class="risksponge-button" (click)="item.editMode = true"
                          *ngIf="!item.editMode"
                          icon="pi pi-pencil"></button>
                  <button type="button" pButton class="risksponge-button"
                          (click)="item.editMode = false; saveAuditItem(item)" *ngIf="item.editMode"
                          icon="pi pi-check"></button>
                  <button type="button" pButton class="risksponge-button"
                          (click)="item.editMode = false;" *ngIf="item.editMode"
                          icon="pi pi-times"></button>
                  <button type="button" pButton class="risksponge-button" (click)="removeAuditItem(item)"
                          icon="pi pi-trash"></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <span class="pi pi-plus"
                (click)="groupedAuditItems[4].push({editMode: true, auditId: auditId, tab: 4})"></span>
        </mat-tab>
        <mat-tab label="Assessor" *ngIf="!isMaster">
          <p-table
            [value]="groupedAuditItems[5]"
            scrollable="true"
          >

            <ng-template pTemplate="header">
              <tr style="white-space: nowrap;font-weight: bold">
                <th *ngFor="let col of assessorCols" [pSortableColumn]="col.field"
                    [ngStyle]="{'width': col.width || 'auto'}">
                  {{col.header}}
                </th>
                <th style="width:10em" pFrozenColumn alignFrozen="right">w</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
              <tr [pSelectableRow]="item">
                                   <td>
                      <ng-container *ngIf="item.editMode">
                        <mat-form-field class="example-full-width" style="width: 100%;">
                          <mat-label>ID</mat-label>
                          <input matInput [(ngModel)]="item.externalId" />
                        </mat-form-field>
                      </ng-container>
                      <ng-container *ngIf="!item.editMode">
                        {{item.externalId}}
                      </ng-container>
                    </td>

                <td>
                  <ng-container *ngIf="item.editMode">
                     <mat-form-field style="width: 100%">
                       <mat-label>Category</mat-label>
                      <input matInput
                             [(ngModel)]="item.type"
                      >

                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{item.type}}
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngIf="item.editMode">
                    <mat-form-field class="example-full-width" style="width: 100%;">
                      <mat-label>Item</mat-label>
                      <input matInput [(ngModel)]="item.name" />
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{item.name}}
                  </ng-container>
                </td>
                <td>
                  <div>
                    <ng-container *ngFor="let file of item.attachments">
                      <div>
                        <a
                          href="{{api + '/api/attachments/file?name=' + encodeURIComponent(file.internalName) + '&path=Audit/' + '&token=' + token}}">{{file.name}}</a>
                        <span class="pi pi-trash" (click)="deleteAttachment(file.attachmentId)"></span>
                      </div>
                    </ng-container>
                  </div>

                  <label type="button"
                         [for]="'flieBlobb' + rowIndex"
                         class="risksponge-button"
                         pTooltip="Add File. {{this.constants.ATTACHMENT_FILE_DESCRIPTION}}">
                    <span class="pi pi-plus"></span>
                  </label>
                  <input [id]="'flieBlobb' + rowIndex"
                         type="file"
                         accept="{{this.constants.ATTACHMENT_FILE_EXTENSIONS}}"
                         (change)="addAttachment($event, item)"
                         [name]="'addAttachedFileb' + rowIndex"
                         style="display: none;"/>
                </td>
                <td>
                  <ng-container *ngIf="item.editMode">
                     <mat-form-field style="width: 100%">
                      <mat-select [(ngModel)]="item.assessorId">
                        <mat-option *ngFor="let user of users"
                                    [value]="user.userId">{{getFullName(user)}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{getFullNameById(item.assessorId)}}
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngIf="item.editMode">
                     <mat-form-field style="width: 100%">
                       <mat-label>Target Due Date</mat-label>
                      <input matInput
                             [matDatepicker]="picker"
                             name="item.dueDate"

                             [(ngModel)]="item.dueDate">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{item.dueDate | date : 'shortDate'}}
                  </ng-container>
                </td>
                <td>
                  <ng-container *ngIf="item.editMode">
                    <mat-form-field style="width: 100%">
                      <mat-label>Status</mat-label>
                      <input matInput
                             [(ngModel)]="item.resolved"
                      >
                    </mat-form-field>
                  </ng-container>
                  <ng-container *ngIf="!item.editMode">
                    {{item.resolved}}
                  </ng-container>
                </td>
                <td>{{item.created | date:'shortDate'}}</td>
                <td pFrozenColumn alignFrozen="right">
                  <button type="button" pButton class="risksponge-button" (click)="item.editMode = true"
                          *ngIf="!item.editMode"
                          icon="pi pi-pencil"></button>
                  <button type="button" pButton class="risksponge-button"
                          (click)="item.editMode = false; saveAuditItem(item)" *ngIf="item.editMode"
                          icon="pi pi-check"></button>
                  <button type="button" pButton class="risksponge-button"
                          (click)="item.editMode = false;" *ngIf="item.editMode"
                          icon="pi pi-times"></button>
                  <button type="button" pButton class="risksponge-button" (click)="removeAuditItem(item)"
                          icon="pi pi-trash"></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
          <span class="pi pi-plus"
                (click)="groupedAuditItems[5].push({editMode: true, auditId: auditId, tab: 5})"></span>
        </mat-tab>
      </mat-tab-group>


    </div>

  </div>
</div>
